import LTR from "@brand-icons/global/anchor-down/anchor-down-ltr.svg";

import { iconFactory } from "../iconFactory";

export const AnchorDownIcon = iconFactory("AnchorDownIcon", LTR);
